import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ContractBillingApiService } from './_internal/contract-billing.api.service';
import { CustomerInterface, GetOptionsResponseInterface } from './_internal/interfaces';

@Injectable()
export class ContractBillingService {
    constructor(private readonly api: ContractBillingApiService) {
    }

    createCustomer(customer: CustomerInterface): Observable<string> {
        return this.api.createCustomer({
            customer: customer
        }).pipe(map(resp => resp.internalCustomerId));
    }
    getOptions(): Observable<GetOptionsResponseInterface> {
        return this.api.getOptions({}).pipe(map(resp => resp));
    }
}
